import PrivateRoutePage from './PrivateRoutePage'

export default PrivateRoutePage
